var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpathy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_17752)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "url(#paint0_linear_10487_17752)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "url(#paint1_radial_10487_17752)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "url(#paint2_radial_10487_17752)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "url(#paint3_radial_10487_17752)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "url(#paint4_radial_10487_17752)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "url(#paint5_radial_10487_17752)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69854 5.8998C9.59854 5.5998 6.39854 5.5998 6.29854 5.8998C6.19854 6.1998 6.89854 6.5998 7.99854 6.5998C9.09854 6.5998 9.79854 6.1998 9.69854 5.8998Z",
    fill: "url(#paint6_linear_10487_17752)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00039 4.1002C6.00039 4.8002 5.60039 5.0002 5.00039 5.1002C4.40039 5.2002 3.90039 4.9002 3.90039 4.1002C3.90039 3.5002 4.20039 2.7002 5.00039 2.7002C5.70039 2.7002 6.00039 3.5002 6.00039 4.1002Z",
    fill: "url(#paint7_radial_10487_17752)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89922 3.0999C4.99922 3.1999 4.99922 3.4999 4.79922 3.5999C4.69922 3.6999 4.49922 3.7999 4.39922 3.5999C4.29922 3.3999 4.29922 3.2999 4.39922 3.0999C4.59922 2.9999 4.79922 2.9999 4.89922 3.0999Z",
    fill: "#4E506A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.1002C10 4.8002 10.4 5.0002 11.1 5.1002C11.7 5.2002 12.2 4.9002 12.2 4.1002C12.2 3.5002 11.9 2.7002 11.1 2.7002C10.3 2.7002 10 3.5002 10 4.1002Z",
    fill: "url(#paint8_radial_10487_17752)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0004 3.1002C11.1004 3.2002 11.0004 3.4002 10.9004 3.6002C10.8004 3.7002 10.6004 3.7002 10.5004 3.6002C10.4004 3.5002 10.5004 3.3002 10.6004 3.1002C10.8004 2.9002 10.9004 2.9002 11.0004 3.1002Z",
    fill: "#4E506A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40082 2.09984C3.20082 2.29984 3.40082 2.59984 3.70082 2.49984C4.30082 2.19984 5.50082 1.89984 6.50082 1.99984C6.80082 1.99984 6.90082 1.99984 6.80082 1.59984C6.80082 1.29984 6.40082 1.09984 5.60082 1.19984C4.40082 1.29984 3.60082 1.89984 3.40082 2.09984Z",
    fill: "url(#paint9_radial_10487_17752)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3996 1.19984C9.59961 1.09984 9.19961 1.29984 9.19961 1.59984C9.09961 1.99984 9.19961 1.99984 9.49961 1.99984C10.5996 1.89984 11.7996 2.19984 12.2996 2.49984C12.6996 2.69984 12.7996 2.29984 12.5996 2.09984C12.3996 1.89984 11.5996 1.29984 10.3996 1.19984Z",
    fill: "url(#paint10_radial_10487_17752)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint11_linear_10487_17752)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint12_radial_10487_17752)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint13_radial_10487_17752)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint14_radial_10487_17752)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint15_radial_10487_17752)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint16_radial_10487_17752)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70029 8.49977C7.60029 7.89977 6.90029 9.29977 6.90029 9.29977C6.90029 9.29977 7.10029 7.69977 5.00029 6.99977C3.00029 6.39977 1.80029 8.29977 1.70029 9.39977C1.50029 11.8998 3.70029 14.6998 4.50029 15.6998C4.60029 15.9998 4.90029 15.9998 5.20029 15.9998C6.40029 15.6998 9.80029 14.5998 11.1003 12.3998C11.6003 11.2998 11.7003 9.09977 9.70029 8.49977Z",
    fill: "url(#paint17_radial_10487_17752)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10487_17752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10487_17752)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29996 7.69977C0.799962 7.19977 -0.100038 6.89977 -0.200038 8.09977C-0.300038 8.99977 0.099962 10.5998 1.19996 11.4998C3.99996 13.6998 6.49996 12.4998 6.59996 10.8998C6.69996 9.69977 5.19996 9.79977 4.79996 9.79977V9.69977C4.89996 9.59977 5.09996 9.49977 5.19996 9.39977C5.59996 9.09977 5.39996 8.59977 4.89996 8.69977C4.79996 8.69977 3.59996 9.09977 2.79996 8.79977C1.99996 8.49977 1.89996 8.19977 1.29996 7.69977Z",
    fill: "url(#paint18_radial_10487_17752)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2987 7.80011C14.5987 7.20011 15.0987 7.40011 15.3987 7.50011C15.7987 7.60011 16.0987 7.90011 16.0987 8.50011C16.0987 10.0001 15.8987 11.4001 14.5987 12.8001C12.2987 15.4001 8.39873 15.0001 7.99873 13.4001C7.69873 12.2001 9.09873 12.0001 9.59873 12.0001V11.9001C9.39873 11.8001 9.29873 11.7001 9.09873 11.6001C8.69873 11.3001 8.79873 10.7001 9.29873 10.8001C9.89873 10.9001 10.6987 11.1001 11.2987 11.0001C13.1987 10.8001 13.4987 9.30011 14.2987 7.80011Z",
    fill: "url(#paint19_radial_10487_17752)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_17752",
    x1: 7.992,
    y1: 15.208,
    x2: 7.992,
    y2: 1.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE86F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.992 7.992) scale(8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28A2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08423",
    stopOpacity: 0.34
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.73068 8.32061) rotate(24.1484) scale(1.616 1.24996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28A2D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28A2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8677 11.7736) rotate(-38.243) scale(4.52801 1.64733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28A2D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28A2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.09371 2.02976) rotate(-10.3559) scale(1.712 0.340446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45F00",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28A2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8914 2.14704) rotate(11.5352) scale(1.696 0.337278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45F00",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45F00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10487_17752",
    x1: 7.99827,
    y1: 5.30912,
    x2: 7.99827,
    y2: 6.73304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A4111"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.99318 4.27134) rotate(-90) scale(1.85963 1.85971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B446B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#202340"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0068 4.27019) rotate(-90) scale(1.85963 1.85971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B446B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#202340"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.00233 1.71049) rotate(-104.427) scale(0.405461 1.87948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD6700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9344 1.53109) rotate(-79.0815) scale(0.427206 2.53522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD6700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10487_17752",
    x1: 6.75366,
    y1: 9.74748,
    x2: 4.72296,
    y2: 16.2896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0820"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.84082 10.9348) rotate(20.3927) scale(2.63291 2.63292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7091",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6D8E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.26853 9.60859) rotate(20.3927) scale(2.63291 2.63292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7091",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6D8E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.98468 11.7622) rotate(101.61) scale(2.26066 3.11294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4144 11.9925) rotate(30.6331) scale(1.36185 1.70916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0600",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.05702 9.11321) rotate(-20.1593) scale(1.18027 1.52097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0600",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.93529 13.9144) rotate(34.0715) scale(1.58883 1.72079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0600",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.0809228 7.46893) rotate(36.5187) scale(6.6485 6.64843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_10487_17752",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6527 7.73711) scale(8.846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC5E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_17752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathy);
export default __webpack_public_path__ + "static/media/empathy.b7234fac7741656e4ea1436d6d215a9b.svg";
export { ForwardRef as ReactComponent };